// extracted by mini-css-extract-plugin
export default {"container":"OutcomesChecklist_container__GOtmw","item":"OutcomesChecklist_item__3hgaU","icon":"OutcomesChecklist_icon__PrQ3n"};